<div class="not-found">
  <img src="assets/images/notfound.svg" alt="notfound">
</div>
